import React from 'react'

export default function Footer() {
    return (
        <footer>
            <div className="contact">
                <p className="lead">Crawford & Company Finland Oy</p>
                <p> Y-tunnus 3097443-9  | <a href="https://www.crawco.com/en-fi">crawco.fi</a> | <span className="mobile-display-block">Tlf. <a href="tel:00358925137530" aria-label="Puhelinnumero">+358925137530</a></span>
                </p>
                <br />
                <p className="copyright">©{new Date().getFullYear()} CRAWFORD & COMPANY</p>
            </div>
        </footer>
    )
}

